import { useLoadScript } from "@react-google-maps/api";
import { getPathLength, isPointWithinRadius } from "geolib";
import Image from "next/image";
import Link from "next/link";
import { createContext, useCallback, useEffect, useState } from "react";
import RycoAutoComplete from "../Common/RycoAutocomplete";
import useTrait from "../Common/syncUpdateState";
import RycoStoresMap from "../WhereToBuy/RycoStoresMap";
export const Context = createContext("where_to_buy");
const libraries = ["places"];

const ResultView = ({ allStores }) => {
  var key = process.env.NEXT_PUBLIC_GOOGLE_MAP_API;
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: key,
    libraries,
  });

  const selectSource = useTrait();
  const useSource = useTrait();
  const selectedLocation = useTrait();
  const postCode = useTrait();
  var stores = useTrait([]);
  var totalStores = useTrait();
  var [activeId, setActiveId] = useState();
  const [active, setActive] = useState({
    state: "NSW",
    postCode: "2000",
    storeList: [],
    lat: -33.869645,
    lon: 151.1872784,
    distance: 5000,
  });

  useEffect(() => {
    // console.log("__", allStores);
    navigator.geolocation.getCurrentPosition((position) => {
      selectSource.set(
        "origin=" +
          position.coords.latitude +
          "," +
          position.coords.longitude +
          "&"
      );
      useSource.set({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        lon: position.coords.longitude,
        storeList: [],
        distance: 10000,
      });

      if (useSource.get()) {
        updateMap(useSource.get());
      }
    });
  }, [allStores]);

  const getSource = () => {};

  const redirectToGoogleMap = useCallback(
    (item) => {
      navigator.geolocation.getCurrentPosition((position) => {
        var source =
          "origin=" +
          position.coords.latitude +
          "," +
          position.coords.longitude +
          "&";
        var destination =
          "destination=" +
          item.flatData.location.latitude +
          "," +
          item.flatData.location.longitude;
        var url =
          "https://www.google.com/maps/dir/?api=1&" + source + destination;
        window.open("url", "_blank");
      });
    },

    []
  );

  const updateMap = useCallback(
    (selectedAddress) => {
      selectedLocation.set(selectedAddress);

      var totalAUStore = allStores.length;

      var searchList = [];
      var start = {
        latitude: selectedLocation.get()?.lat,
        longitude: selectedLocation.get()?.lon,
      };
      for (var i = 0; i < totalAUStore; i++) {
        var end = {
          latitude: allStores[i].flatData?.location?.latitude,
          longitude: allStores[i].flatData?.location?.longitude,
        };
        if (
          isPointWithinRadius(
            start != undefined ? start : "",
            end != undefined ? end : "",
            selectedLocation.get().distance
          )
        ) {
          allStores[i].distance = getPathLength([start, end]);

          searchList.push(allStores[i]);
        }
      }
      //console.log("search_", searchList);
      stores.set(
        searchList.sort((a, b) =>
          a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0
        )
      );
      postCode.set(selectedLocation.get().postcode);
      totalStores.set(searchList.length);
    },
    [selectedLocation, allStores, postCode, stores, totalStores]
  );

  const [storesOfSelectedList, setStoresOfSelectedList] = useState(
    allStores[0]?.storeList
  );

  if (loadError) return "Error";
  if (!isLoaded) return <div className='text-center'>Loading...</div>;

  return (
    <>
      <div className='container'>
        <div className='row'>
          <h1 className='fs-2 fw-bold lh-1 mt-5 js-video-category'>
            Where To Buy
          </h1>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className='row d-flex justify-content-center'>
              <div className='col-md-6 col-sm-12'>
                <Context.Provider value={{ updateMap }}>
                  <RycoAutoComplete />
                </Context.Provider>
              </div>
            </div>
            <div className='row my-5'>
              <div className='col-md-6'>
                <RycoStoresMap
                  allMapStores={stores.get()}
                  activeId={activeId}
                  selectedLocation={selectedLocation}
                  selectSource={useSource.get()}
                />
              </div>
              <div className='col-md-6'>
                {stores && (
                  <div key='_store_key' className='row'>
                    {stores?.get()?.map((item) => (
                      <div key={item.id} className='col-md-6 mb-3'>
                        <div className='card p-2'>
                          <h5>
                            <strong>{item?.flatData?.title}</strong>
                          </h5>
                          <p>
                            <span>
                              <Image
                                src="/icons/location.svg"
                                width='20'
                                height='20'
                                alt='Address'
                                layout='raw'
                              />
                            </span>
                            &nbsp; {item?.flatData?.address.trim()}
                          </p>
                          <p>
                            <span>
                              <Image
                                src="/icons/warehouse.svg"
                                width='20'
                                height='20'
                                alt='Address'
                                layout='raw'
                              />
                            </span>
                            &nbsp; {item?.flatData?.suburb}{" "}
                            {item?.flatData?.state} {item?.flatData?.postcode}
                          </p>

                          {item?.flatData?.phone && (
                            <p>
                              <span>
                                <Image
                                  src="/icons/phone-call.svg"
                                  width='20'
                                  height='20'
                                  alt='Address'
                                  layout='raw'
                                />
                              </span>
                              &nbsp;
                              <Link href={`tel:${item?.flatData?.phone}`} legacyBehavior>
                                <a>{item?.flatData?.phone}</a>
                                </Link>
                            </p>
                          )}
                          {item?.flatData?.website && (
                            <p>
                              <span>
                                <Image
                                  src="/icons/arrow-right.svg"
                                  width='20'
                                  height='20'
                                  alt='Website'
                                  layout='raw'
                                />
                              </span>
                              &nbsp;
                              <Link
                                href={
                                  /^https?:\/\//i.test(item?.flatData?.website)
                                    ? item?.flatData?.website
                                    : `https://${item?.flatData?.website}`
                                }
                                legacyBehavior
                              >
                                <a target='_blank' rel='noopener noreferrer' title={item?.flatData?.website} aria-label='Visit website'>
                                  Visit website
                                </a>
                              </Link>
                            </p>
                          )}
                          {item?.distance && (
                            <p>
                              <span>
                                <Image
                                  src="/icons/distance.svg"
                                  width='20'
                                  height='20'
                                  alt='Address'
                                  layout='raw'
                                />
                              </span>
                              &nbsp;
                              <span>
                                distance {(item?.distance / 1000).toFixed(1)} km
                              </span>
                            </p>
                          )}
                          {item.flatData.location.latitude &&
                            item.flatData.location.longitude && (
                              <Link
                                type='button'
                                style={{ borderRadius: 2 }}
                                className='btn btn-outline-danger btn-sm'
                                href={
                                  "https://www.google.com/maps/dir/?api=1&" +
                                  selectSource?.get() +
                                  "destination=" +
                                  item.flatData.location.latitude +
                                  "," +
                                  item.flatData.location.longitude
                                }
                                target='_blank'
                                rel='noopener noreferrer'
                              >
                                Get Directions &nbsp;{" "}
                                <span>
                                  <Image
                                    src="/icons/location.svg"
                                    width='16'
                                    height='16'
                                    alt='Map Direction'
                                    layout='raw'
                                  />
                                </span>
                              </Link>
                            )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className='col-md-6'></div>
            </div>
          </div>
          <div className='col-md-6 col-sm-12 col-xs-12'></div>
        </div>
      </div>
    </>
  );
};

export default ResultView;
